<!--div *ngIf="loading">
    <div class="loader"><img src="assets/images/loading.svg" alt="Loader" /></div>
</div-->
<div *ngIf="!loading" >
    <div *ngIf="emptyFlag" [ngClass]="{ 'preset-list' : !presetshowPOPUPFlag }">
        <div class="no-item-list no-item-list-preset" [style.height.px]="innerHeight">
            <div class="item-empty-container">
                <img src="assets/images/preset/empty-preset-img.png" alt="" />
                <div>
                    <span class="empty-res">Get started by tapping on "New Preset".</span>
                </div>
                <div>
                    <span class="cursor add-btn" (click)="openPresetsAction('new','')">
                        <span ><i  class="pi pi-plus" style="font-size: 14px;margin-right: 4px;color: #ffffff;"></i></span>
                        <span class="save-text">New Preset</span>
                    </span>
                </div>
            </div>
        </div>
     </div>
     <div [ngClass]="{ 'preset-list' : !presetshowPOPUPFlag }" *ngIf="!emptyFlag && noResult && presetsData.length == 0">
        <div class="no-item-list no-item-list-preset" [style.height.px]="innerHeight">
            <div class="item-empty-container">
                <img src="assets/images/no-result-media.png" alt="no-result-media" style="width: 112px;height: 102px;" width="112" height="102">
                <div>
                    <span class="empty-res">No result found</span>
                </div>                             
            </div>
        </div>
     </div> 
    <div [ngClass]="{ 'preset-list' : !presetshowPOPUPFlag }" *ngIf="!emptyFlag && presetsData && presetsData.length>0" [style.height.px]="innerHeight">
        <div #top id="step" class="ps form-fields" [perfectScrollbar]="sconfig" (scroll)="onScroll($event)"> 
             
             <div >
                <p-accordion class="report-section custom-accordion flat-custom-accordion thread-detail-accordion" *ngFor="let item of presetsData; let s = index;"
                (onClose)="onTabClose(s)" (onOpen)="onTabOpen(s)">
                    <p-accordionTab id="section-{{s}}" class="presets-list-{{item.id}} section list-div-row" [transitionOptions]="'100ms'" [selected]="item.isSelected" [ngClass]="{ 'list-div-row-active' : item.listSelected }">
                        <p-header class="sec-info">
                            <div class="content-div">                                                                    
                                <div class="content-title">
                                    <span class="persets-title-overflow" [title]="item.titleMakeModelYearPH" [innerHTML]="item.titleMakeModelYear | highlight : toHighlight"></span>
                                    <!--span >{{item.title}}</span-->                                       
                                    <!--span class="content-makemodel" [innerHTML]="item.makeModel"></span>-->                                
                                </div> 
                                <div class="content-more">
                                    <div id="more" class="more-icon">
                                        <div class="actions-div">
                                            <div *ngIf="presetshowPOPUPFlag" id="add-button" title="Select" class="add-button active" (click)="openPresetsAction('emit',item)"><span class="add-button-text">SELECT</span><img src="assets/images/thread/pp-add-icon.png"></div>
                                            
                                            <span *ngIf="item.editAccess" title="Edit" (click)="openPresetsAction('edit',item.presetIdInt)">
                                                <img src="assets/images/thread-detail/thread-edit.svg" alt="" onload="SVGInject(this)">
                                            </span>  
                                            <span *ngIf="item.deleteAccess" class="ml-3" title="Delete" (click)="deletePresetsAction(item.presetIdInt);$event.stopPropagation();">
                                                <img src="assets/images/thread-detail/thread-delete.svg" alt="" onload="SVGInject(this)">
                                            </span> 

                                        </div>
                                    </div>
                                </div>                                 
                            </div>  
                        </p-header>
                        <div class="content-list" id="cont-list-{{s}}">
                            <div class="content-div">
                                <div class="content-desc ck-content">
                                    <span [innerHTML]="item.content"></span> 
                                </div>                                          
                                <div class="attachment-div presets-div">                     
                                    <app-attachment-view *ngIf="!item.attachmentLoading" [loading]="item.attachmentLoading" [action]="item.action" [dynamicGid]="'0'+item.id" [access]="pageAccess"  [attachments]="item.attachments" ></app-attachment-view>
                                </div>
                                <div *ngIf="item.tagList?.length>0">
                                    <div class="tag-info" style="padding: 5px 0;">
                                        <div class="tags">
                                            <span class="list-txt tag-txt">Tag</span>
                                            <div class="tag-list-div">
                                                <span class="tag-list" *ngFor="let tag of item.tagList">{{tag}}</span>                                            
                                            </div>                                         
                                        </div>
                                    </div>
                                </div> 
                                <div class="content-posted-detail">
                                    <span class="profile-img">
                                        <!--<img onerror="this.src='assets/images/thumb_profile_image.png'" class="post-p-img" [src]="item.profileImage" >-->
                                        <div class="tooltipUseDiv" (mouseleave)="t.close();">  
                                            <div class="tooltipUseDivInner" (mouseenter)="getUserProfileStatus(item.userId,s);t.open();$event.stopPropagation();"></div>                                                        
                                            <img tooltipClass="profile-tooltip" triggers="manual" #t="ngbTooltip" [autoClose]="false" placement="bottom-left" [ngbTooltip]="profileTT" class="post-p-img" [src]="item.profileImage" onerror="this.src='assets/images/thumb_profile_image.png'" />
                                         </div>

                                         <ng-template #profileTT  >
                                            <div (mouseleave)="t.close();" class="edit-history-div visibilityHidden" [ngClass]="{ 'visibilityVisible' : item.profileShow } ">
                                                <div class="table-row2">
                                                    <div class="profile-tt-row">
                                                        <div class="profile-tt-col-lt profile-status-tt">
                                                            <img class="" src="assets/images/thread/profile-status-{{item.availability}}.svg"/>
                                                        </div>
                                                        <div class="profile-tt-col-rt">                                                          
                                                            <p class="profile-text-tt">{{item.availabilityStatusName}}</p>      
                                                        </div>					
                                                    </div>
                                                    <div class="line"></div>
                                                    <div class="profile-tt-row cursor-pointer" (click)="taponprofileclick(item.userId);$event.stopPropagation();">
                                                        <div class="profile-tt-col-lt">
                                                            <img src="assets/images/thread-detail/tooltip-viewprofile.png" />
                                                        </div>
                                                        <div class="profile-tt-col-rt">                                                                        
                                                            <p class="profile-text-tt">View Profile</p>      
                                                        </div> 
                                                    </div>
                                                </div>  
                                            </div>    
                                        </ng-template>

                                    </span>
                                    <span class="profile-text">{{item.userNameStr}}</span>                                    
                                    <span class="profile-text">{{item.createdDate}}</span>
                                </div>
                            </div> 
                        </div>                      
                    </p-accordionTab>
                </p-accordion>
                <div class="lazy-loading" *ngIf="lazyLoading"><img src="assets/images/landing-page/loading-more.svg" alt="Loader" /></div>
            </div>
        </div>
    </div>
</div>
